'use client';

import Image from 'next/image';
import clsx from 'clsx';

export const SmallCardWithImage = ({
  image,
  altImage,
  direction,
  size,
  title,
  content,
}: {
  image: string;
  altImage: string;
  title: string;
  content: string;
  direction: string;
  size: string;
}) => {
  return (
    <li
      className={clsx(
        'mx-auto flex max-w-xs flex-1 flex-row justify-center gap-5 p-5',
        direction === 'vertical' && 'lg:flex-col lg:justify-start',
      )}
    >
      <Image
        className={clsx('object-contain', size === 'medium' ? 'size-24' : 'size-16')}
        src={image}
        alt={altImage}
        height={80}
        width={80}
      />
      <div className={clsx('flex flex-col gap-3', direction === 'vertical' && 'flex-grow')}>
        <h3 className={clsx('text-xl', direction === 'vertical' && '')}>{title}</h3>
        <p className="text-text-body">{content}</p>
      </div>
    </li>
  );
};
